import { Box, Grid, Tab } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { StyledTabs } from '../../common/StyledComponents';
import Tags from '../tags/Tags';
import { fetchOrganization, fetchPricelistMailingSchedule } from './redux/settingsSlices';
import { ApplicationSettingsTab } from './tabs/ApplicationSettingsTab';
import OrganizationSettingsTab from './tabs/OrganizationSettingsTab';
import PricelistMailingSettingsTab from './tabs/PricelistMailingSettingsTab';
import ProductCategoriesTab from './tabs/ProductCategoriesTab';
import WarehouseSettingsTab from './tabs/WarehouseSettingsTab';

export const Settings = () => {
    const [tabIndex, setTabIndex] = useState(0);

    const dispatch = useDispatch();

    const handleTabChange = (newTabIndex: number) => {
        setTabIndex(newTabIndex);
    };

    useEffect(() => {
        dispatch(fetchOrganization.request());
        dispatch(fetchPricelistMailingSchedule.request());
    }, [dispatch]);

    return (
        <Grid sx={{ flexFlow: 'row' }} container>
            <Grid item xs={9} sx={{ paddingLeft: '10px' }}>
                <StyledTabs
                    value={tabIndex}
                    onChange={(e, idx) => handleTabChange(idx)}
                    indicatorColor="primary"
                    textColor="primary"
                >
                    <Tab label="Warehouses" />
                    <Tab label="Organization" />
                    <Tab label="Pricelist mailing" />
                    <Tab label="Application settings" />
                    <Tab label="Product categories/-groups" />
                    <Tab label="Tags" />
                </StyledTabs>

                <Box p={2}>
                    {tabIndex === 0 && <WarehouseSettingsTab />}
                    {tabIndex === 1 && <OrganizationSettingsTab />}
                    {tabIndex === 2 && <PricelistMailingSettingsTab />}
                    {tabIndex === 3 && <ApplicationSettingsTab />}
                    {tabIndex === 4 && <ProductCategoriesTab />}
                    {tabIndex === 5 && <Tags />}
                </Box>
            </Grid>
        </Grid>
    );
};
